import { render, staticRenderFns } from "./x-textarea.vue?vue&type=template&id=f8bc0074&scoped=true&"
import script from "./x-textarea.vue?vue&type=script&lang=js&"
export * from "./x-textarea.vue?vue&type=script&lang=js&"
import style0 from "./x-textarea.vue?vue&type=style&index=0&id=f8bc0074&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bc0074",
  null
  
)

export default component.exports